import { ImportOutlined } from '@ant-design/icons';
import { Button, Col, Form, Radio, Row, Space, Steps, Tag, Typography, } from 'antd';
import React, { useEffect, useState } from 'react';
import AddMemberComponent from './AddMember';
import colorsDark from '../../../assets/colors/dark';
import { openMessage } from '../../../redux/actions';
import { NOTIFIES } from '../../../constants/system.keys';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const { Step } = Steps;
const AddMemberSteps = ({
  namespace,
  handleAddMemberDone,
  onAddMember,
  keyMember,
  fileData,
  onConfigTimeoutMember,
  submitFileUpload,
  handleFileUpload,
  setFileData,
  onCloseModalAddMember,
  setUserType,
}) => {
  const [current, setCurrent] = useState(0);
  const [methodAdd, setMethodAdd] = useState(1);
  const [form] = Form.useForm();
  const [valuesForm, setValuesForm] = useState({});
  const [requestId, setRequestId] = useState();
  const [addDataReturn, setAddDataReturn] = useState();
  const { addMemberToNamespace } = useSelector((state) => state);
  const [uploadResults, setUploadResults] = useState([]);
  const [dataUpload, setDataUpload] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (addMemberToNamespace) {
      if (addMemberToNamespace) {
        setUploadResults((pre) => [...pre, addMemberToNamespace]);
      }
    }
  }, [addMemberToNamespace]);

  useEffect(() => {
    const dataUpload = uploadResults.map((item, index) => {
      if (item.result === 1) {
        return {
          ...item.data,
          status: 'success',
        };
      } else if (item.result === -1) {
        return {
          ...fileData[index],
          status: 'invalid',
        };
      } else {
        return {
          ...fileData[index],
          status: 'failed',
        };
      }
    });

    if (dataUpload?.length > 0) {
      handleAddMemberDone(dataUpload);
    }
    setDataUpload(dataUpload);
  }, [addMemberToNamespace, fileData, handleAddMemberDone, uploadResults]);

  useEffect(() => {
    if (addDataReturn) {
      const { result, data, message } = addDataReturn;
      if (result === 1) {
        const dataLiveTimeout = form.getFieldValue('liveTimeout');
        openMessage(NOTIFIES.SUCCESS, message);
        form.resetFields();
        form.setFieldsValue({
          namespace: namespace,
        });
        if (addDataReturn?.data?.accountId && dataLiveTimeout) {
          const dataObjConfig = {
            liveTimeout:
              moment(dataLiveTimeout)?.hours() * 3600 +
              moment(dataLiveTimeout)?.minutes() * 60,
            accountId: addDataReturn?.data?.accountId,
            namespace,
          };
          onConfigTimeoutMember(dataObjConfig);
        }
        handleAddMemberDone(data);
      } else {
        openMessage(NOTIFIES.WARNING, message);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addDataReturn, form, namespace, handleAddMemberDone]);

  useEffect(() => {
    if (addMemberToNamespace && addMemberToNamespace.requestId === requestId) {
      setAddDataReturn(addMemberToNamespace);
    }
  }, [addMemberToNamespace, requestId]);

  const next = () => {
    if (current === 0) {
      form.resetFields();
    }

    if (current === 1) {
      form
        .validateFields()
        .then((values) => {
          setValuesForm(values);
          form.resetFields();
          setCurrent(current + 1);
        })
        .catch((info) => {
          console.log('Validate Failed:', info);
        });
      return;
    }

    if (current === 2) {
      if (methodAdd === 1) {
        let current = new Date().getTime();
        setFileData([valuesForm]);
        setRequestId(current);
        onAddMember(current, valuesForm);
      } else {
        submitFileUpload();
      }
    }

    if (current === 3) {
      setCurrent(0);
      setFileData([]);
      setValuesForm({});
      setDataUpload([]);
      onCloseModalAddMember();
    }

    setCurrent(current + 1);
  };

  const onChangeMethod = (e) => {
    setMethodAdd(e.target.value);
  };

  const numberFileSuccess =
    dataUpload.filter((item) => item?.status === 'success').length || 0;

  const onChangeStep = (step) => {
    if (current === 0) {
      setValuesForm({});
    }
    setCurrent((state) => (state > step ? step : state));
  };
  const [isFormValid, setIsFormValid] = useState(false);

  const handleFormChange = () => {
    form
      .validateFields()
      .then(() => {
        setIsFormValid(true);
      })
      .catch((e) => {
        if (e.errorFields?.length === 0) {
          setIsFormValid(true);
        } else {
          setIsFormValid(false);
        }
      });
  };

  return (
    <div className="steps-add-member">
      <Steps
        size="small"
        type="navigation"
        current={current}
        onChange={onChangeStep}
        className="site-navigation-steps"
      >
        <Step title={t('Add method')}></Step>
        <Step disabled={current === 3} title={t('Infomation')}></Step>
        <Step disabled={current === 3} title={t('Preview')}></Step>
        <Step title={t('Done')}></Step>
      </Steps>

      <Typography.Paragraph style={{ marginTop: 20, fontSize: 12 }}>
        {t(
          'You can choose to enter information for each account or import data from an Excel file.'
        )}
      </Typography.Paragraph>

      {current === 0 && (
        <Radio.Group
          style={{
            marginTop: 20,
          }}
          onChange={onChangeMethod}
          value={methodAdd}
        >
          <Space direction="vertical">
            <Radio value={1}>{t('Enter each account')}</Radio>
            <Radio value={2}>{t('Import from excel file')}</Radio>
          </Space>
        </Radio.Group>
      )}
      <div className="add-whitelist-ip-component">
        <Form
          {...layout}
          onValuesChange={handleFormChange}
          initialValues={valuesForm}
          form={form}
          name="form_in_modal"
        >
          {current === 1 && (
            <div>
              {methodAdd === 1 && (
                <div
                  style={{
                    marginTop: 20,
                  }}
                >
                  <AddMemberComponent
                    form={form}
                    setUserType={setUserType}
                    requestId={requestId}
                    namespace={namespace}
                    onAdd={onAddMember}
                    onDone={handleAddMemberDone}
                    keyMember={keyMember}
                  />
                </div>
              )}
              {methodAdd === 2 && (
                <>
                  <div
                    style={{
                      fontSize: 12,
                      color: '#ffffffa6',
                      textAlign: 'center',
                      margin: '10px 0',
                    }}
                  >
                    <a
                      style={{ textDecoration: 'underline' }}
                      href="https://db1.beex.vn/members.xlsx"
                    >
                      {t('Download template')}
                    </a>
                    &nbsp;
                    {t(
                      'and fill in member information. Then import the file to add members'
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <input
                      type="file"
                      accept=".xlsx"
                      onChange={(e) => {
                        handleFileUpload(e);
                        setCurrent(current + 1);
                      }}
                      style={{ display: 'none' }}
                      id="fileUpload"
                    />
                    <Button
                      icon={<ImportOutlined />}
                      type="primary"
                      onClick={() => {
                        document.getElementById('fileUpload').click();
                      }}
                    >
                      {t('Import list members')}
                    </Button>
                  </div>
                </>
              )}
            </div>
          )}

          {current === 2 && (
            <div style={{ marginTop: 20 }}>
              {methodAdd === 1 && valuesForm && (
                <div>
                  <p>
                    <b>{t('FullName')}:</b> {valuesForm?.fullName}
                  </p>
                  <p>
                    <b>{t('Email')}:</b> {valuesForm?.email}
                  </p>
                  <p>
                    <b>{t('Phone')}:</b> {valuesForm?.phonenumber}
                  </p>
                  <p>
                    <b>{t('Position')}:</b> {valuesForm?.position}
                  </p>
                  <p>
                    <b>{t('Permission')}:</b> {valuesForm?.role}
                  </p>
                  <p>
                    <b>{t('Role')}:</b> {valuesForm?.detailRoles}
                  </p>
                  <p>
                    <b>{t('Enable Watermark')}:</b> {valuesForm?.enableWatermark ? t('Enable') : t('Disable')}
                  </p>
                </div>
              )}

              {methodAdd === 2 && (
                <>
                  {fileData?.map((item, index) => (
                    <Row
                      key={index}
                      gutter={16}
                      style={{ width: '100%', marginBottom: 5 }}
                    >
                      <Col span={6}>
                        <span
                          style={{
                            fontSize: '13px',
                            fontWeight: 600,
                          }}
                        >
                          {item.phonenumber}
                        </span>
                      </Col>
                      <Col span={6}>{item.fullName}</Col>
                      <Col span={6}>
                        <Tag
                          color={
                            item?.role === 'admin'
                              ? colorsDark.$online
                              : colorsDark.$offline
                          }
                        >
                          {item.role && item.role.toUpperCase()}
                        </Tag>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </div>
          )}

          {current === 3 && (
            <div style={{ marginTop: 10 }}>
              <Tag>{`${numberFileSuccess}/${fileData?.length} accounts`}</Tag>
              {fileData?.map((item, index) => (
                <Row
                  key={index}
                  gutter={16}
                  style={{ width: '100%', marginBottom: 5 }}
                >
                  <Col span={6}>
                    <span
                      style={{
                        fontSize: '13px',
                        fontWeight: 600,
                      }}
                    >
                      {item.phonenumber}
                    </span>
                  </Col>
                  <Col span={6}>{item.fullName}</Col>
                  <Col span={6}>
                    <Tag
                      color={
                        item.role === 'admin'
                          ? colorsDark.$online
                          : colorsDark.$offline
                      }
                    >
                      {item.role && item.role.toUpperCase()}
                    </Tag>
                  </Col>
                  <Col span={6}>
                    <Tag
                      color={
                        dataUpload?.[index]?.status === 'success'
                          ? colorsDark.$online
                          : dataUpload?.[index]?.status === 'error'
                          ? colorsDark.$error
                          : dataUpload?.[index]?.status === 'invalid'
                          ? colorsDark.$error
                          : colorsDark.$warning
                      }
                    >
                      {dataUpload?.[index]?.status || 'loading'}
                    </Tag>
                  </Col>
                </Row>
              ))}
            </div>
          )}

          <div
            style={{
              display: 'flex',
              gap: 8,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              type="primary"
              onClick={next}
              disabled={current === 1 && !isFormValid}
            >
              {
                {
                  0: t('Next'),
                  1: t('Next'),
                  2: t('Create'),
                  3: t('Done'),
                }[current]
              }
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddMemberSteps;
